/**
 * Dashboard feature flags — centralised so tests can assert the contract.
 *
 * All three flags default OFF per V3 page-01 fork hard-stops. Flip
 * individually post-Codex via Vite env:
 *   VITE_DASHBOARD_EXPLAIN_PANEL=1
 *   VITE_DASHBOARD_ANOMALIES=1
 *   VITE_DASHBOARD_TIME_WINDOW=1
 *
 * Mirror of isSidebarRegistryEnabled() in PageRegistryContext.tsx — same
 * import.meta.env guarded pattern for non-Vite test envs.
 */

function readFlag(name: string): boolean {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const env = (import.meta as any)?.env || {}
    const flag = env[name]
    return flag === '1' || flag === 'true' || flag === true
  } catch {
    return false
  }
}

export function isDashboardExplainPanelEnabled(): boolean {
  return readFlag('VITE_DASHBOARD_EXPLAIN_PANEL')
}

export function isDashboardAnomaliesEnabled(): boolean {
  return readFlag('VITE_DASHBOARD_ANOMALIES')
}

export function isDashboardTimeWindowEnabled(): boolean {
  return readFlag('VITE_DASHBOARD_TIME_WINDOW')
}
